export default {
  methods: {
    getAltText(txt) {
      if (!txt) {
        return ''
      }
      return txt
        .match(new RegExp(/[a-z0-9-\säöü]+/gi))
        .join('')
        .replace('  ', ' ')
    }
  }
}
